import React, { useState,useEffect} from "react";
import "./FridgeService.css";
import SingleDoorFridgeRepair from "../images/Single-Door-Fridge-Repair.webp";
import DoubleDoorService from "../images/Double Door Service.webp";
import FridgeInstallation from "../images/Fridge Installation.webp";
import CompressorRepair from "../images/Compressor Repair.webp";
import  FridgeMaintenance from "../images/Fridge Maintenance.webp";
import    DoorstepFridgeRepair from "../images/Doorstep Fridge Repair.webp";
import FridgeService1 from "../images/fridgehero.webp";
import customer1 from "../images/cutomer1.webp";





function FridgeService() {
       useEffect(() => {
  
      document.title =
        "Fridge Service - Embarque Services";
  
    }, []);
  
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      location: "",
      issue: "",
    });
  
    const [loading, setLoading] = useState(false);
  
    const handleChange = (e) => {
  
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
  
    };
  
    const handleSubmit = async (e) => {
  
      e.preventDefault();
  
      setLoading(true);
  
      const sendData = {
        ...formData,
        toMail: "expresshelplinecare@gmail.com",
      };
  
      try {
  
        const res = await fetch(
          "https://form.e2ecrm.in/api/sendmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData),
          }
        );
  
        await res.json();
  
        alert(
          "Thank you! Your service request is confirmed. Our engineer will call you shortly."
        );
  
        setFormData({
          name: "",
          phone: "",
          location: "",
          issue: "",
        });
  
      } catch (err) {
  
        console.log(err);
  
        alert("Error sending form");
  
      } finally {
  
        setLoading(false);
  
      }
    };
  
  return (
   <>
   
      {/* SPINNER */}

      {loading && (

        <div className="spinner-overlay">

          <div className="spinner"></div>

        </div>

      )}

      {/* FRIDGE HERO SECTION */}

      <div className="fridge-home">

        <section className="fridge-hero">

          {/* LEFT APPLIANCE */}

          <div className="fridge-appliance-section">

            {/* <img
              className="fridge-machine-img"
              src="https://cdn-icons-png.flaticon.com/512/1046/1046857.png"
              alt="Fridge Service"
            /> */}

          </div>

          {/* CONTENT */}

          <div className="fridge-content">

            <h1>
              Refrigerator <br />
              Repair & <br />
              Maintenance <br />
              Service At <br />
              Your Doorsteps
            </h1>

          </div>

          {/* FORM */}

          <div className="fridge-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your refrigerator service complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the refrigerator issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>


              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

        </section>

      </div>

      
{/* FRIDGE ABOUT SECTION */}

<section className="fridge-about-section">

  <div className="fridge-about-left">

    <h1>
      Trusted Fridge <br />
      Repair Experts <br />
      for Your <br />
      Home Needs
    </h1>

    <div className="fridge-about-box">

      <p>
        With 8+ years of experience in refrigerator repair,
        our technicians provide quick and reliable service support.
      </p>

      <p>
        From cooling problems to compressor issues,
        we handle all major fridge brands professionally.
      </p>

    </div>

  </div>

  <div className="fridge-about-right">

    <h4>
      OUR SERVICE ACHIEVEMENTS
    </h4>

    <div className="fridge-counter-grid">

      <div className="fridge-counter-box">
        <h1>8+</h1>
        <p>Years Experience</p>
      </div>

      <div className="fridge-counter-box">
        <h1>45000+</h1>
        <p>Fridge Repairs</p>
      </div>

      <div className="fridge-counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="fridge-counter-box">
        <h1>22+</h1>
        <p>Service Areas</p>
      </div>

    </div>

  </div>

</section>

{/* FRIDGE SERVICES SECTION */}

<section className="fridge-services-section">

  <h1 className="fridge-service-title">
    Our Refrigerator Services
  </h1>

  <div className="fridge-services-grid">

    <div className="fridge-service-card">

      <img
        src={SingleDoorFridgeRepair} alt="single door fridge"
      />

      <h2>
        Single Door Fridge Repair
      </h2>

      <p>
        Fast repair support for cooling, thermostat,
        and freezer issues in single door refrigerators.
      </p>

    </div>

    <div className="fridge-service-card">

      <img
        src={DoubleDoorService} alt="double door fridge"
      />

      <h2>
        Double Door Service
      </h2>

      <p>
        Professional refrigerator servicing and maintenance
        for double door fridge models.
      </p>

    </div>

    <div className="fridge-service-card">

      <img
        src={FridgeInstallation}
        alt="installation"
      />

      <h2>
        Fridge Installation
      </h2>

      <p>
        Safe refrigerator installation and setup support
        at your home or office.
      </p>

    </div>

    <div className="fridge-service-card">

      <img
        src={CompressorRepair}  alt="compressor repair"
      />

      <h2>
        Compressor Repair
      </h2>

      <p>
        Expert repair solutions for compressor noise,
        cooling failure, and gas leakage issues.
      </p>

    </div>

    <div className="fridge-service-card">

      <img
        src={ FridgeMaintenance} alt="maintenance"
      />

      <h2>
        Fridge Maintenance
      </h2>

      <p>
        Regular maintenance support to improve cooling
        performance and product life.
      </p>

    </div>

    <div className="fridge-service-card">

      <img
        src={DoorstepFridgeRepair}  alt="doorstep service"
      />

      <h2>
        Doorstep Fridge Repair
      </h2>

      <p>
        Fast doorstep refrigerator repair support
        from experienced technicians.
      </p>

    </div>

  </div>

</section>

{/* FRIDGE WHY CHOOSE US */}

<section className="fridge-choose-section">

  <div className="fridge-choose-overlay">

    <h4>
      WHY CHOOSE OUR FRIDGE SERVICE
    </h4>

    <h1>
      Trusted Refrigerator <br />
      Repair Solutions
    </h1>

    <div className="fridge-choose-grid">

      {/* BOX 1 */}

      <div className="fridge-choose-box">

        <div className="fridge-choose-icon">
          ❄️
        </div>

        <h2>
          Expert Fridge Repair
        </h2>

      </div>

      {/* BOX 2 */}

      <div className="fridge-choose-box">

        <div className="fridge-choose-icon">
          ⏰
        </div>

        <h2>
          Same Day Service
        </h2>

      </div>

      {/* BOX 3 */}

      <div className="fridge-choose-box">

        <div className="fridge-choose-icon">
          💰
        </div>

        <h2>
          Affordable Pricing
        </h2>

      </div>

      {/* BOX 4 */}

      <div className="fridge-choose-box">

        <div className="fridge-choose-icon">
          🚚
        </div>

        <h2>
          Doorstep Support
        </h2>

      </div>

      {/* BOX 5 */}

      <div className="fridge-choose-box">

        <div className="fridge-choose-icon">
          🧊
        </div>

        <h2>
          Cooling Solutions
        </h2>

      </div>

      {/* BOX 6 */}

      <div className="fridge-choose-box">

        <div className="fridge-choose-icon">
          👨‍🔧
        </div>

        <h2>
          Experienced Technicians
        </h2>

      </div>

    </div>

  </div>

</section>

{/* FRIDGE REQUEST INFO */}

<section className="fridge-request-section">

  {/* Left Content */}

  <div className="fridge-request-left">

    <h1>
      Refrigerator <br />
      Repair Support
    </h1>

    <h2>
      Fast & Reliable Fridge <br />
      Service at <br />
      Your Doorstep
    </h2>

    <p>
      We provide complete refrigerator repair and maintenance
      solutions for homes and offices. Our experienced technicians
      handle cooling problems, gas leakage, compressor repair,
      thermostat issues, installation, and servicing with
      professional doorstep support at affordable pricing.
    </p>

  </div>

 

  <div className="fridge-request-right">

    <img
      src={FridgeService1} alt="fridge service"
    />

  </div>

</section>



{/* <section className="fridge-support-section">

 

  <div className="fridge-support-image">

    <img
      src={customer1} alt="fridge customer support"
    />

  </div>

 

  <div className="fridge-support-content">

    <h1>
      Refrigerator Customer Support
    </h1>

   

    <div className="fridge-support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="fridge-support-box">
      <span>+</span>
      <p>Same Day Technician Visit</p>
    </div>

    <div className="fridge-support-box">
      <span>+</span>
      <p>Professional Single & Double Door Support</p>
    </div>

    <div className="fridge-support-box">
      <span>+</span>
      <p>Experienced Fridge Repair Technicians</p>
    </div>

    <div className="fridge-support-box">
      <span>+</span>
      <p>Affordable Refrigerator Service Charges</p>
    </div>

  </div>

</section> */}


{/* FRIDGE FAQ SECTION */}

{/* <section className="fridge-faq-section">

  <div className="fridge-faq-title">

    <h4>
      FAQ
    </h4>

    <h1>
      Refrigerator Service Questions
    </h1>

  </div>

  <div className="fridge-faq-container">

    

    <div className="fridge-faq-box">

      <h2>
        What refrigerator issues do you repair?
      </h2>

      <p>
        We repair cooling issues, gas leakage, compressor failure,
        thermostat problems, water leakage, and unusual noise issues.
      </p>

    </div>

  

    <div className="fridge-faq-box">

      <h2>
        Do you repair all refrigerator brands?
      </h2>

      <p>
        Yes, we provide repair and maintenance support
        for all major refrigerator brands and models.
      </p>

    </div>

  

    <div className="fridge-faq-box">

      <h2>
        Do you provide doorstep fridge service?
      </h2>

      <p>
        Yes, our experienced technicians provide fast
        doorstep refrigerator repair and inspection support.
      </p>

    </div>

  

    <div className="fridge-faq-box">

      <h2>
        How quickly can I book a refrigerator service?
      </h2>

      <p>
        You can book your refrigerator service instantly
        through phone call or WhatsApp support.
      </p>

    </div>

   

    <div className="fridge-faq-box">

      <h2>
        Do you provide compressor repair support?
      </h2>

      <p>
        Yes, we provide professional compressor repair
        and replacement support for refrigerators.
      </p>

    </div>

  

    <div className="fridge-faq-box">

      <h2>
        Are your service charges affordable?
      </h2>

      <p>
        Yes, we provide transparent and affordable
        refrigerator repair pricing with quality service.
      </p>

    </div>

  </div>

</section> */}


<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>


<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>
   </>
  );
}

export default FridgeService;